// Unpublished Work © 2020-2025 Deere & Company.

import {SET_USER_DATA} from '../action-list';
import {getUser} from '../repositories/user';
import {setConfiguration} from './configuration';

export const setUserData = (businessActivities) => async (dispatch) => {
    const activities = {
        canAddEdit: businessActivities.canAddEdit,
        canMerge: businessActivities.canMerge
    };

    const {
        businessActivities: returnedBusinessActivities,
        ...user
    } = await getUser(activities);

    window.wmUserInfo = {
        'countryCode': user.country,
        'isBranch29User': user.isBranch29User,
        'r2CRMUser': user.r2CRMUser
    };

    dispatch(setConfiguration({
        businessActivities: returnedBusinessActivities
    }));

    dispatch({
        type: SET_USER_DATA,
        user
    });
};
